export enum RoleName {
  SYSTEM_ADMIN = 'System Admin',
  ADMIN = 'Admin',
  ANALYST = 'Analyst',
  INSPECTOR = 'Inspector',
  AUDITOR = 'Auditor',
  CITIZEN = 'Citizen',
}
